export const getAppURL = async () => process.env.NEXT_PUBLIC_URL;
